var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-steps",
    { attrs: { active: _vm.active, "align-center": "" } },
    [
      _c("el-step", { attrs: { title: "受付番号確認" } }),
      _vm._v(" "),
      _c("el-step", { attrs: { title: "商品・お届先入力" } }),
      _vm._v(" "),
      _c("el-step", { attrs: { title: "受付内容確認" } }),
      _vm._v(" "),
      _c("el-step", { attrs: { title: "受付完了" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-157109dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157109dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/parts/ex/AppSteps.vue
// module id = null
// module chunks = 